import { InputText } from './input-text'

export { InputText }
